import type { ApplicationModule, ApplicationModuleCode } from '@/domain/application-modules/application-module.interface';
import type { Observable } from 'rxjs';
import type { ProjectId } from '../../interfaces/Project.interface';

export abstract class ApplicationModulesService {
    abstract fetchApplicationModules(projectId: ProjectId): Promise<ApplicationModule[]>;
    abstract getApplicationModules$(): Observable<ApplicationModule[]>;
    abstract hasModuleAccess$(code: ApplicationModuleCode): Observable<boolean>;
    abstract hasModuleAccess(code: ApplicationModuleCode): Promise<boolean>;
    abstract hasModuleAccessR(code: ApplicationModuleCode): boolean;
    abstract hasEveryoneAccessToModuleInCurrentProject$(code: ApplicationModuleCode): Observable<boolean>;
}
